/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ContactType = {
    PHONE: 'PHONE',
    EMAIL: 'EMAIL'
} as const;
export type ContactType = typeof ContactType[keyof typeof ContactType];

